export const ptBr = {
    values: {
        Shifts: 'Turnos',
        'New Shift': 'Novo Turno',
        'Create shifts per Rigs': 'Criar turnos por Sonda',
        'Successfully saved': 'Salvo com sucesso',
        'Sections successfully saved': 'Seções salvas com sucesso',
        'Shift Name': 'Nome do Turno',
        Squad: 'Equipe',
        'Start (h)': 'Início (h)',
        'End (h)': 'Fim (h)',
        Color: 'Cor',
        'Pipes functions': 'Funções Pipes',
        'Pipe Functions Created': 'Funções Pipes Criadas',
        'Pipe Functions Created Description':
            'As seguintes funções Pipes foram criadas pelo plugin. Clique em uma função para abrir um exemplo de uso no console.',
        Close: 'Fechar',
        'pipe-fn-getAll-desc': 'Retorna todas as sondas e seus respectivos turnos configurados.',
        'pipe-fn-get-desc': 'Retorna os turnos configurados para uma sonda específica.',
        'pipe-fn-isBetween-desc':
            'Verifica se um intervalo de tempo (em ms) sobrepõe algum turno da sonda. Usa o timezone do sistema.',
        'pipe-fn-isBetweenWithTimezone-desc':
            'Verifica se um intervalo de tempo (em ms) sobrepõe algum turno da sonda com timezone explícito.',
        'pipe-fn-getMatchedShiftWithTimestamp-desc':
            'Retorna o turno correspondente a um timestamp (em ms). Usa o timezone do sistema.',
        'pipe-fn-getMatchedShiftWithTimestampAndTimezone-desc':
            'Retorna o turno correspondente a um timestamp (em ms) com timezone explícito.',
        'pipe-fn-getMatchedShiftBetweenTimestamps-desc':
            'Retorna o turno que se sobrepõe a um intervalo de tempo (em ms). Usa o timezone do sistema.',
        'pipe-fn-getMatchedShiftBetweenTimestampsWithTimezone-desc':
            'Retorna o turno que se sobrepõe a um intervalo de tempo (em ms) com timezone explícito.'
    }
}
